import React from "react";
import Text from "@src/lib/ui/Text";
import { useUserContextState } from "@src/lib/contexts/UserContext";
import { getTimeOfDay } from "@src/lib/utils/dates";
import {
  RecentlyEditedModulesSection,
  useHasRecentlyEditedModules,
} from "./RecentlyEditedModulesWidget";

const HomeQuickActions: React.FC = () => {
  const { user } = useUserContextState();
  const hasRecentlyEditedModules = useHasRecentlyEditedModules();

  if (!user?.firstName && !hasRecentlyEditedModules) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      {user?.firstName && (
        <Text variant="display">
          Good {getTimeOfDay()}, {user.firstName}
        </Text>
      )}
      <RecentlyEditedModulesSection />
    </div>
  );
};

export default HomeQuickActions;
